<template>

    <div class="mt-10">

        <div class="sticky top-0 z-20 bg-white w-full">

            <!-- <div class="barTitleDiv">

                <label class="barTitleText">{{$t('menu.memberships')}}</label>
            </div> -->

            <!-- <div class="">
                
                <slot></slot>
            </div>

            <div>

                <my-tabs :itemIsSelected="tabIsSelected"/>
            </div> -->

            <div class="w-full border border-gray-200" :key="studiosMemberships.length">

                <memberships-panel :panelObject="panelObject" :allMemberships="studiosMemberships" ref="sessionsPanel"
               :fixedDayDate="fixedDayDate" :isClass="false" :refreshMap="refreshMap"
                 :setDate="setDateFromPanel" :countiesOptions="countiesOptions">

                    <slot></slot>

                    <div v-if="!isFromBusinessBrowse">

                        <my-tabs :itemIsSelected="tabIsSelected"/>
                    </div>
                    

                </memberships-panel>
            </div>
        </div>

        <div class="mySessionsMainDiv" v-if="!loading">

            <div class="overflow-y-scroll w-full h-full allText mb-40">

                <transition  name="right-in">

                    <div v-if="showMap" class="myMapDiv mb-40">
                        
                        <studios-memberships-map-modal :showModal="showMap" :modalMemberships="panelObject.categorizedMemberships" :highlightedLocation="highlightedLcoation"
                       :myReload="myReload" :isCard="true" :displayModal="displayModal" :showDescription="showDescription" 
                        :dayDate="panelObject.dayDate" :disableButton="disableButton" :refreshedMap="refreshedMap"
                        :changeShowModal="changeShowMapModal" :showOnlyTheOneMembership="showOnlyTheOneMembership" :oneMembership="selectedOneMembership"/>
                    </div>
                </transition>

                <transition name="bottom-up">

                    <div v-if="displayMembershipPage"
                    class="modalDiv myFullCenter h-full">
                        
                        <div class="subModalDiv" v-click-outside="closeMembershipPage">

                            <studio-membership-page :userId="userId" :myMembership="myMembership" :closeMembershipPage="closeMembershipPage"
                            :reload="myReload" :setMainRefreshPageReady="setRefreshPageReady"/>
                        </div>
                    </div>
                </transition>

                <div v-show="!showMap">

                    <div v-if="panelObject.categorizedMemberships.length > 0"
                    class="myColCenter mainMembershipList mb-20">

                        <div class="mySessionsDivider">
                            
                            <div class="myCardDiv" :key="membership.id" 
                             v-for="(membership, index) in panelObject.categorizedMemberships" >

                                <studio-membership-card :tokenId="tokenId" :key="panelObject.dayDate" :index="index"
                                :email="email" :myReload="myReload" :isCard="true" :displayModal="displayModal"
                                :membership="membership" :disableButton="disableButton"
                                :disablePage="disablePage" :showDescription="showDescription"
                                 :dayDate="panelObject.dayDate"/>
                            </div>
                        </div>
                    </div>

                    <div v-else class="h-40">
                        
                        <div class="myFullCenter mt-40">
                            
                            <p class="mt-2 lg:mt-5 p-5 bg-blue-300 rounded-full border-blue-800 border-4">
                                <strong>{{$t('memberships.noSessionsAvailable')}}</strong></p>
                        </div>
                    </div>
                </div>                
            </div>
        </div>

        <div v-else class="w-full flex justify-center mt-10">
            
            <ring-loader ></ring-loader> 
        </div>
    </div>
</template>

<script>



import myTabs from '../../components-v2/controls/MySessionsTabs'

// import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'


import studioMembershipCard from './StudioMembershipCard';

import membershipsPanel from './MembershipsPanel';

import moment from 'moment';

import studiosMembershipsMapModal from './StudiosMembershipsMapModal';

import componentsHelpers from '../../classes/componentHelpers';

import studioMembershipPage from './StudioMembershipPage';

import componentsMethods from '../../classes/componentsMethods';

export default {

     created(){

        this.todayDate = this.dayDate;        
    },

    async mounted(){
        
        await this.loadData();
        // this.setDates();

        // this.membershipsTypesOptions = this.category.filter(item => item.is_ma == true);


        this.countiesOptions = this.county;

        this.slotSubscribeError = '';

        this.bookingsSubscribeError = '';

        this.slotError = '';

        const myFilter = item => Number(item.id) == Number(parameters.selected);        
    },


    components:{

        myTabs,
        studioMembershipCard,
        studiosMembershipsMapModal,
        studioMembershipPage,
        membershipsPanel,
    },

    props:{

        myBusinessId: 0,

        isFromBusinessBrowse: false,

        itemIsSelected:{

            type: Function
        },

        myTabsList:{

            type: Array,
        },

        user:{

            type:Object
        },
        
        myReload: {

            type: Function
        },

        category:{
        
            type: Array
        },

        county:{
        
            type: Array
        },

        tokenId: 0,

        location:{
        
            type: Array
        },
    },

    methods:{ 

        async loadData(){

            try{

                const countryName = 'Kuwait';

                this.loading = true;

                let result;
                
                if(this.isFromBusinessBrowse){
                   
                    result = await axios({method: 'post',url: '/pnadiapi/forPublicInfo/getStudiosMembershipsWithId',
                        data: {
                        
                            countryName: countryName,
                            businessId: this.myBusinessId,
                        }
                });

                }else{

                    result = await axios({method: 'post',url: '/pnadiapi/forPublicInfo/getStudiosMemberships',
                        data: {
                        
                            countryName: countryName,
                        }
                });
                }

    

            // console.log(`result.data.length: ${JSON.stringify(result.data.two_pitch_slot.length)}`);

                this.studiosMemberships = result.data.three_studio_membership;

                this.loading = false;

            }catch(error){

                this.loading = false;

                componentsHelpers.sendError(this.$apollo, this.userId,'PublicInfo', 'studiosMemberships', 'loadData', error);

                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
                
                this.gymsMembershipsError = JSON.stringify(error);
            }
        },

        refreshMap(){

            // console.log(`in refreshMap`)
            this.refreshedMap++;
        },        

        tabIsSelected(tab){

            if(tab == 2){

                this.showMap = true;;
            }else{

                this.showMap = false;
            }
        },

        setDates(){


            this.myDates = componentsMethods.getDates();

        },

        setDateFromBar(date){

            const tempDate = moment(date).format(moment.HTML5_FMT.DATE);
            this.panelObject.dayDate = tempDate;

            this.$refs.sessionsPanel.setNewDate(tempDate)
            this.$refs.sessionsPanel.setSlots();
        },

        setDateFromPanel(date, isNext){

            this.panelObject.dayDate = moment(date).format(moment.HTML5_FMT.DATE);
            this.$refs.sessionsBar.changeDate(isNext);
        },

        showDescription(membership){

            this.showMembershipPage(membership);
        },

        isIos(){

            return componentsHelpers.isIos();
        },

        sendAddAnEvent(newEvent){
  

            if(typeof window.webkit != 'undefined'){
                
                window.webkit.messageHandlers.addAnEvent.postMessage(JSON.stringify(newEvent));
            }else{

            }                  
        },

        showMembershipPage(membership){

            this.myMembership = membership;

            this.displayMembershipPage = true;
        },

        setRefreshPageReady(value){

            this.refreshPageReady = value;

            // console.log(`setRefreshPageReady: ${value}`);
        },

        closeMembershipPage(){

            // console.log(`refreshPage: ${refreshPage}`);
            this.myMembership = null;

            this.displayMembershipPage = false;

            if(this.refreshPageReady == true){

            //    console.log(`page refreshed`)
                this.myReload();
            }
        },

         openOneSlotMapModal(membership){

            this.showOnlyTheOneMembership = true;
            this.selectedOneMembership = membership;
            this.showMap = true;
        },
        
        async sleep(ms){
        
        this.count = this.count + 1;
        return await new Promise(resolve => setTimeout(resolve, ms));
        },

        displayModal(modalImages){

            if(modalImages.length > 0){  

                this.modalImages = modalImages;

                this.changeShowModal(true);
            }
        },

        changeShowModal(val){

            if(val == false){

                this.modalImages = [];
            }

            this.showModal = val;
        },

        changeShowMapModal(val){

            this.showMap = val;
            this.showOnlyTheOneMembership = val;
            this.selectedOneMembership = null;
        },
        
        setHighlightedLocation(index){

            this.highlightedLcoation = this.panelObject.categorizedSlots[index].class.location;
        },
    },

    data: function(){

        return{

            loading: false,

            panelObject:{

                minimizeAll: false,
                onlyOnline: false,
                categorizedMemberships: new Array(),
                dayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
            },

            myDates: [],

            weekDays:[
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
                'Sunday'
            ],

            showOnlyTheOneMembership: false,
            selectedOneMembership: null,
            disablePage: false,
            disableButton: false,
            highlightedLcoation: null,
            showModal: false,
            showMap: false,
            userId:this.user? this.user.id : 0,
            email:'',
            // membershipsTypesOptions: this.category,
            countiesOptions: this.county,
            studiosMemberships: [],
            studiosMembershipsError: '',
            dayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
            fixedDayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
            todayDate: '',
            storedKey: localStorage.getItem('for_pnadi'),
            displayMembershipPage: false,
            myMembership: null,

            refreshedMap: 0,
        }
    },


}
</script>

<style>
/* height: 250px;
width: 250px; */
/* transform: translate(-50%, -50%); */

.bottom-up-enter-active{

    animation: slide-bottom-up 0.5s ease-in;
}

.bottom-up-leave-active{
    
    animation: slide-top-down 0.5s ease-in;
}

@keyframes slide-bottom-up{
        from  { transform: translateY(100%);}
        to { transform: translateY(0);} 
}
@keyframes slide-top-down{
    from  { transform: translateY(0%);}
    to { transform: translateY(100%);} 
}

.right-in-enter-active{

    animation: slide-right-in 0.5s ease-in;
}

.right-in-leave-active{
    
    animation: slide-right-out 0.5s ease-in;
}

@keyframes slide-right-in{
        from  { transform: translateX(100%);}
        to { transform: translateX(0);} 
}
@keyframes slide-right-out{
    from  { transform: translateX(0%);}
    to { transform: translateX(100%);} 
}


</style>